Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    COLORS = _STYLES$useStyles.COLORS,
    bp = _STYLES$useStyles.bp,
    spacing = _STYLES$useStyles.spacing,
    fontRegular = _STYLES$useStyles.fontRegular,
    fontSemiBold = _STYLES$useStyles.fontSemiBold,
    boxShadows = _STYLES$useStyles.boxShadows;
  var container = {};
  var nativeContainer = Object.assign({}, boxShadows.button.ios, {
    backgroundColor: COLORS.white,
    borderRadius: (0, _styles.getREM)(0.625)
  });
  var text = Object.assign({
    display: 'flex',
    maxWidth: _styles.STYLES.grid.maxInputWidth,
    minHeight: (0, _styles.getREM)(3.75),
    flexDirection: 'column',
    flexWrap: 'nowrap',
    justifyContent: 'center',
    borderRadius: (0, _styles.getREM)(0.625),
    overflow: 'hidden',
    backgroundColor: COLORS.paper,
    borderColor: COLORS.white,
    borderWidth: (0, _styles.getREM)(0.1875),
    borderStyle: 'solid',
    paddingTop: spacing.normal,
    paddingBottom: spacing.normal,
    paddingLeft: spacing.l,
    paddingRight: spacing.l,
    textAlign: 'left'
  }, boxShadows.button.web, boxShadows.button.android);
  if (bp.is([bp.mobile_xs, bp.mobile_s])) {
    text.paddingTop = spacing.xs;
    text.paddingBottom = spacing.xs;
    text.paddingLeft = spacing.xs;
    text.paddingRight = spacing.xs;
  }
  if (bp.desktop) {
    text.paddingTop = spacing.m;
    text.paddingBottom = spacing.m;
  }
  if (_reactNative.Platform.OS === 'android') {
    text.paddingTop = text.paddingTop * 1.3;
    text.paddingBottom = text.paddingBottom * 0.7;
  }
  var text_selected = {
    backgroundColor: COLORS.cherry
  };
  var text_pointerOver = Object.assign({}, boxShadows.button_pointerOver.web);
  var labelContainer = {
    marginBottom: 0
  };
  var label = Object.assign({}, fontSemiBold, {
    fontSize: _styles.STYLES.fontSize.s,
    lineHeight: _styles.STYLES.lineHeight.s,
    color: COLORS.aubergine
  });
  if (bp.is([bp.mobile_l, bp.mobile_xl, bp.tablet])) {
    label.fontSize = _styles.STYLES.fontSize.normal;
    label.lineHeight = _styles.STYLES.lineHeight.normal;
  }
  if (bp.desktop) {
    label.fontSize = _styles.STYLES.fontSize.m;
    label.lineHeight = _styles.STYLES.lineHeight.m;
  }
  var label_selected = {
    color: COLORS.white
  };
  var descriptionContainer = {
    marginBottom: 0
  };
  var description = Object.assign({}, fontRegular, {
    fontSize: _styles.STYLES.fontSize.s,
    lineHeight: _styles.STYLES.lineHeight.s,
    color: COLORS.doveGrey
  });
  var description_selected = {
    color: COLORS.white
  };
  var styles = _reactNative.StyleSheet.create({
    container: container,
    nativeContainer: nativeContainer,
    text: text,
    text_selected: text_selected,
    text_pointerOver: text_pointerOver,
    labelContainer: labelContainer,
    label: label,
    label_selected: label_selected,
    descriptionContainer: descriptionContainer,
    description: description,
    description_selected: description_selected
  });
  return {
    styles: styles
  };
};